import React, { useContext, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faAddressCard, faLanguage, faE, faBus, faPen, faEye, faSync, faTimes, faBuildingCircleCheck, faCalendarWeek} from '@fortawesome/free-solid-svg-icons';
import CountUp from 'react-countup';
import { Card, Row, Col, OverlayTrigger, Tooltip, Button, Form } from "react-bootstrap";
import { CSSTransition } from 'react-transition-group';
import ChartsContext from "contexts/ChartsContext";
import TodayRegistration from "./DetailsTable/TodayRegistration";
import CheckinTable from "./DetailsTable/CheckinTable";
import Papa from 'papaparse';
import { useHistory } from 'react-router-dom';


function DataSnapshots({ onRefresh }) {
  const [showCheckinTable, setShowCheckinTable] = useState(false);
  const [showTotalToday, setShowTotalToday] = useState(false);

  const history = useHistory();

  const handleFullListDetailsClick = () => {
    history.push('/admin/eventregadmin');
  };
  const {
    updateTime,
    totalEntries,
    totalToday,
    checkIns,
    relativesCount,
    totalHeadCount,
    checkInGroupSizeTotal
  } = useContext(ChartsContext);

  // Function to handle PDF download (to be implemented)
  const handleCSVDownload = (data, filename) => {
    // Define the column order
    const columnOrder = [
      'id', 
      'firstname', 
      'lastname', 
      'chinesename', 
      'email', 
      'phone', 
      'checkedIn', 
      'lastNotificationSent', 
      'checkedInTime', 
      'registrationTime'
    ];
    

    // Use PapaParse to unparse the data with the specified columns
    const csv = Papa.unparse({
      fields: columnOrder,
      data: data.map(row => columnOrder.reduce((obj, key) => ({ ...obj, [key]: row[key] }), {}))
    }, {
      quotes: false, // Quote all fields
      quoteChar: '"',
      escapeChar: '"',
      delimiter: ",",
      header: true,
      newline: "\r\n",
      skipEmptyLines: false, // Skip empty lines
      columns: columnOrder // Ensure the columns are in the correct order
    });

    // Create a Blob from the CSV String with UTF-8 BOM to ensure proper display of Chinese characters
    const BOM = "\uFEFF";
    const csvBlob = new Blob([BOM + csv], { type: 'text/csv;charset=utf-8;' });

    // Create a link and trigger the download
    const csvUrl = URL.createObjectURL(csvBlob);
    const downloadLink = document.createElement('a');
    downloadLink.href = csvUrl;
    downloadLink.setAttribute('download', `${filename}.csv`);
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };


  // Function to handle closing (to be implemented)
  const handleTableClose = (table) => {
    if (table === 'checkin') {
      setShowCheckinTable(false);
    }
    else if (table === 'totalToday') {
      setShowTotalToday(false);
    }
  };

  const handleDetailsButtonClick = (table) => {
    setShowCheckinTable(table === 'checkin');
    setShowTotalToday(table === 'totalToday');
  };

  return (
    <>
      <Row>
        {/* Total Registrations Card */}
        <Col lg="4" sm="6">
          <div className="card-container">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning">
                      {/* <FontAwesomeIcon icon={faUsers} className="text-info" /> */}
                      <span className="text-info">總報名</span>
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category font-weight-bold">素食展<span className="text-warning">總</span>報名人數</p>
                      <Card.Title as="h2" className="font-weight-bold text-dark">
                        <CountUp end={totalEntries} duration={2.75} />
                        <span className="h6"> 人</span>
                      </Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top1">Details</Tooltip>}>
              <Button className="btn-round btn-outline details-button" variant="twitter" onClick={handleFullListDetailsClick}>
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </OverlayTrigger>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
              <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>


        {/* Today‘s registration Card */}
        <Col lg="4" sm="6">
          <div className="card-container">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning">
                      {/* <FontAwesomeIcon icon={faCalendarWeek} className="text-success" /> */}
                      <span className="text-success">今日報名</span>
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category font-weight-bold">素食展<span className="text-warning">今日</span>報名人數</p>
                      <Card.Title as="h2" className="font-weight-bold text-dark">
                        <CountUp end={totalToday} duration={2.75} />
                        <span className="h6"> 人</span>
                      </Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top1">Details</Tooltip>}>
              <Button className="btn-round btn-outline details-button" variant="twitter" onClick={() => handleDetailsButtonClick('totalToday')}>
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </OverlayTrigger>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
              <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>

        {/* Check-in Card */}
        <Col lg="4" sm="6">
          <div className="card-container">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning">
                      {/* <FontAwesomeIcon icon={faBuildingCircleCheck} className="text-body" /> */}
                      <span className="text-body">已到場</span>
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category font-weight-bold">素食展已<span className="text-warning">已到場</span>總人數</p>
                      <Card.Title as="h2" className="font-weight-bold text-dark">
                        <CountUp end={checkInGroupSizeTotal} duration={2.75} />
                        <span className="h6"> 人</span>
                      </Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top1">Details</Tooltip>}>
              <Button className="btn-round btn-outline details-button" variant="twitter" onClick={() => handleDetailsButtonClick('checkin')}>
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </OverlayTrigger>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
              <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>
      </Row>


      <Row>

        {/* Today‘s registration Card */}
        <Col lg="4" sm="6">
          <div className="card-container">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning">
                      {/* <FontAwesomeIcon icon={faUsers} className="text-warning" /> */}
                      <span className="text-warning">隨行</span>
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category font-weight-bold">素食展<span className="text-warning">隨行</span>人數</p>
                      <Card.Title as="h2" className="font-weight-bold text-dark">
                        <CountUp end={relativesCount} duration={2.75} />
                        <span className="h6"> 人</span>
                      </Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
              <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>

        {/* Check-in Card */}
        <Col lg="4" sm="6">
          <div className="card-container">
            <Card className="card-stats">
              <Card.Body>
                <Row>
                  <Col xs="5">
                    <div className="icon-big text-center icon-warning">
                      {/* <FontAwesomeIcon icon={faUsers} className="text-danger" /> */}
                      <span className="text-danger">總人數</span>
                    </div>
                  </Col>
                  <Col xs="7">
                    <div className="numbers">
                      <p className="card-category font-weight-bold">素食展<span className="text-danger">預計到場總</span>人數</p>
                      <Card.Title as="h2" className="font-weight-bold text-dark">
                        <CountUp end={totalHeadCount} duration={2.75} />
                        <span className="h6"> 人</span>
                      </Card.Title>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer>
                <hr />
                <div className="stats">
                  <i className="fas fa-redo mr-1"></i>
                  Updated at <span className="font-weight-bold">{updateTime}</span>
                </div>
              </Card.Footer>
            </Card>
            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top2">Refresh</Tooltip>}>
              <Button className="btn-round btn-outline refresh-button" variant="warning" onClick={onRefresh}>
                <FontAwesomeIcon icon={faSync} />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>
      </Row>



      <CSSTransition in={showCheckinTable} timeout={300} classNames="table-transition" unmountOnExit>
        <Row>
          <Col md="12">
            <CheckinTable handleCSVDownload={handleCSVDownload} handleTableClose={() => handleTableClose('checkin')} />
          </Col>
        </Row>
      </CSSTransition>

      <CSSTransition in={showTotalToday} timeout={300} classNames="table-transition" unmountOnExit>
        <Row>
          <Col md="12">
            <TodayRegistration handleCSVDownload={handleCSVDownload} handleTableClose={() => handleTableClose('totalToday')} />
          </Col>
        </Row>
      </CSSTransition>
    </>
  );
}

export default DataSnapshots;
